module.exports = __webpack_public_path__ + "static/media/ico_image.86dd7cb7.svg";